import React, { Component } from 'react';
import { schemeApi } from '@dym/client-bridge';
import './index.css';
import { ajaxFn, commonUtil } from '../../lib/common/DYUtil';
import DYShare from '../../lib/common/DYShare';
import Ponits from '../../points';
import DYBrowser from '../../lib/common/base';

class Clockin extends Component {
    constructor() {
        super();

        this.config = {
            // 获取上一天活动信息
            getLastDayActivityInfo: '/actives/signActivity/getLastDayActivityInfo',
            // 获取当前总鱼丸数
            getSignInfo: '/actives/signActivity/getSignInfo'
        };

        this.state = {
            averYuwan: 0,
            totalYuwan: 0
        };

        this.clickApplyBtn = this.clickApplyBtn.bind(this);
    }

    componentDidMount () {
        this.getAverageYuwanData();
        this.getCurTotalYuwan();
    }

    // 获取人均瓜分鱼丸数
    getAverageYuwanData () {
        ajaxFn({
            url: this.config.getLastDayActivityInfo,
            success: (res) => {
                if (+res.error === 0) {
                    const oData = res.data || {};
                    const ywTotal = oData.ywTotal || 0;
                    const joinTotal = oData.joinTotal || 0;
                    let averageYuwan = 0;

                    if (ywTotal && joinTotal) {
                        averageYuwan = parseInt(ywTotal / joinTotal, 10);
                        averageYuwan = commonUtil.formatNum1(averageYuwan);
                    }

                    this.setState({
                        averYuwan: averageYuwan
                    });
                    this.initShare(averageYuwan);
                } else {
                    this.initShare(200);
                }
            },
            error: () => {
                this.initShare(200);
            }
        });
    }

    initShare (yuwan) {
        const shareData = {
            shareSetting: {
                // 标题
                title: '我在斗鱼签到赚鱼丸',
                // 描述
                desc: `点击参与瓜分海量鱼丸，昨日平均瓜分${yuwan || 200}鱼丸`,
                // 链接
                link: window.location.href,
                // 图片
                imgUrl: 'https://sta-op.douyucdn.cn/dyfelocal/act/5acc7c96d51caa4669f8b2de/signinShare.png'
            }
        };

        return new DYShare(shareData);
    }

    // 获取当前总鱼丸数
    getCurTotalYuwan () {
        ajaxFn({
            url: this.config.getSignInfo,
            success: (res) => {
                if (+res.error === 0) {
                    const oData = res.data || {};
                    const tYW = oData.ywTotal || 0;

                    this.setState({
                        totalYuwan: tYW
                    });
                }
            }
        });
    }

    // 点击立即报名按钮
    clickApplyBtn () {
        Ponits.click_ywact_share_signup();
        schemeApi.jsNative.openAPPWelcometoPage({
            id: 57
        });
    }

    render () {
        const { averYuwan, totalYuwan } = this.state;

        return (
            <div className="Clockin">
                <div className="Clockin-title">
                    <div className="Clockin-titleName">
                        <span className="Clockin-titleNameText">昨日人均瓜分</span>
                        <span className="Clockin-titleNameText ttnum">{averYuwan || 200}</span>
                        <span className="Clockin-titleNameText">鱼丸</span>
                    </div>
                </div>
                <div className="Clockin-totalYuwanTitle">当前总额(鱼丸)</div>
                <div className="Clockin-totalYuwanNum">{commonUtil.formatNum1(totalYuwan, 'y') || 10000}</div>
                <div className="Clockin-applyBtn" onClick={this.clickApplyBtn}>打卡瓜分以上鱼丸</div>
                <div className="Clockin-steps">
                    <div className="Clockin-stepsTitle">三步瓜分鱼丸</div>
                    <div className="Clockin-stepsShow"></div>
                </div>
            </div>
        );
    }
}

export default Clockin;
